// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { NewsInfoResponseDTO } from "../../api/backend-openapi";

export const setNews = createEvent<NewsInfoResponseDTO[]>("SET_NEWS");
export const addNews = createEvent<NewsInfoResponseDTO>("ADD_NEWS");
export const deleteNews = createEvent<string>("DELETE_NEWS");
export const updateNews = createEvent<NewsInfoResponseDTO>("UPDATE_NEWS");
